import * as clubApi from "shadow-client/endpoints/clubApi";
import * as saleApi from "shadow-client/endpoints/saleApi";
import { compose, lifecycle, withHandlers, withState } from "recompose";
import { connect } from "react-redux";
import { formatPattern } from "react-router-utils";
import { getCart, getCartSale } from "app/redux/selectors";
import { getCartArticleIds, getCartSaleId } from "app/redux/modules/cart";
import { getClubs } from "shadow-client/redux/selectors";
import { withTranslator } from "app/decorators";
import HomePage from "./HomePage";
import _clearCart from "app/redux/actions/clearCart";

const mapStateToProps = (state, { clubIds }) => ({
  clubs: getClubs(state, clubIds),
  cartSaleId: getCartSaleId(getCart(state)),
  cartArticleIds: getCartArticleIds(getCart(state)),
  sale: getCartSale(state)
});

function componentWillMount() {
  const { searchValue, cartSaleId, findClubsMatchingParams, fetchSale, setGeolocAvailable } = this.props;
  findClubsMatchingParams({ q: searchValue });

  if (cartSaleId) {
    fetchSale(cartSaleId);
  }

  if ("geolocation" in navigator) {
    setGeolocAvailable(true);
  }
}

function componentWillReceiveProps(nextProps) {
  const { findClubsMatchingParams } = this.props;

  if (nextProps.searchValue !== this.props.searchValue) {
    findClubsMatchingParams({ q: nextProps.searchValue });
  }
}

const findClubsMatchingParams = ({ setIsLoading, fetchClubList, setClubIds }) => searchParam => {
  setIsLoading(true);

  fetchClubList({
    params: { ...searchParam, "clubTags.name": "web", eshop: true }
  }).then(response => {
    setClubIds(response["hydra:member"].map(entity => entity.get("@id")));
    setIsLoading(false);
  });
};

const onSearchValueChange = ({ setSearchValue }) => event => {
  setSearchValue(event.target.value);
};

const onGeoloc = ({ setPosition, findClubsMatchingParams }) => event => {
  navigator.geolocation.getCurrentPosition(function(position) {
    findClubsMatchingParams({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      radius: 100
    });
    setPosition({
      lat: position.coords.latitude,
      lon: position.coords.longitude
    });
  });
};

const onDeletePosition = ({ setPosition, searchValue, findClubsMatchingParams }) => event => {
  setPosition();
  findClubsMatchingParams({ q: searchValue });
};

const onChangeClub = ({
  setIsOpen,
  history,
  sale,
  cartSaleId,
  cartArticleIds,
  setClubId,
  clearCart
}) => selectedClubId => {
  if (cartSaleId && cartArticleIds.size && sale.get("clubId") !== selectedClubId) {
    setIsOpen(true);
    setClubId(selectedClubId);
  } else if (cartSaleId && !cartArticleIds.size && sale.get("clubId") !== selectedClubId) {
    clearCart().then(
      () => {
        history.push(formatPattern("/:clubId/shop", { clubId: selectedClubId }));
      },
      () => {
        alert("Un problème est survenu.");
      }
    );
  } else {
    history.push(formatPattern("/:clubId/shop", { clubId: selectedClubId }));
  }
};

const onChangeClubConfirm = ({ history, clearCart, clubId }) => () => {
  clearCart().then(
    () => {
      history.push(formatPattern("/:clubId/shop", { clubId: clubId }));
    },
    () => {
      alert("Un problème est survenu.");
    }
  );
};

const onClose = ({ setIsOpen }) => () => {
  setIsOpen(false);
};

export default compose(
  connect(null, {
    fetchClubList: clubApi.fetchClubList,
    fetchSale: saleApi.fetchSale,
    clearCart: _clearCart
  }),
  withState("isLoading", "setIsLoading", true),
  withState("clubIds", "setClubIds"),
  withState("clubId", "setClubId"),
  withState("isOpen", "setIsOpen", false),
  withState("geolocAvailable", "setGeolocAvailable", false),
  withState("position", "setPosition"),
  withState("searchValue", "setSearchValue", ""),
  connect(mapStateToProps),
  withHandlers({ findClubsMatchingParams }),
  withHandlers({
    onSearchValueChange,
    onChangeClubConfirm,
    onClose,
    onGeoloc,
    onChangeClub
  }),
  withHandlers({ onDeletePosition }),
  lifecycle({ componentWillMount, componentWillReceiveProps }),
  withTranslator
)(HomePage);



// WEBPACK FOOTER //
// ./src/app/components/HomePage/HomePageContainer.js